import http from 'core/services/http';
import Config from 'core/config';
import isObject from 'lodash/isObject';
import { toQueryString } from 'shared/helpers';

class EventChecklistService {
  static getEventTasks(eventId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/tasks${queryString}`);
  }

  static updateTask(eventId, taskData) {
    return http.put(`${Config.apiUrl}/testcenterevent/${eventId}/completetasks`, taskData);
  }
}

export default EventChecklistService;
